<template>
    <section class="projectCont">

        <div class="projectLogo_cont">
            <img :src="projectData.icon[0]" alt="project logo" class="projectLogo" />
        </div>
        
        <div class="projDet">
            <h2 class="projName">{{ projectData.title }}</h2>
            <p class="projDesc" v-html="projectData.desc"></p>

            <div class="projFooter">
                <router-link :to="`/projects/${projectData.title}`">
                    See more
                </router-link>
            </div> 
        </div>
    </section>
</template>

<script>
export default {
    props: {
        projectData: Object,
        tools: Object
    },

    methods: {
        getIcon(name) {
            for (let i = 0; i < this.tools.known.length; i++) {
                if (this.tools.known[i][1] == name) {
                return this.tools.known[i][0];
                }
            }

            for (let i = 0; i < this.tools.diving.length; i++) {
                if (this.tools.diving[i][1] == name) {
                return this.tools.diving[i][0];
                }
            }

            for (let i = 0; i < this.tools.db.length; i++) {
                if (this.tools.db[i][1] == name) {
                return this.tools.db[i][0];
                }
            }

            for (let i = 0; i < this.tools.lang.length; i++) {
                if (this.tools.lang[i][1] == name) {
                return this.tools.lang[i][0];
                }
            }
        },
    }
}

</script>

<style scoped lang="scss">

    .projectCont {
        width: 85%;
        height: auto;
        display: flex;
        align-items: center;
        background: #99999904;
        border-radius: 5px;
        box-shadow: 0px 0px 5px #000000ab;
        -webkit-backdrop-filter: blur(6.2px);
        backdrop-filter: blur(6.2px);
        margin: auto;
        overflow: hidden;
        max-height: 190px;
    }

    .projectLogo_cont {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
        height: 100%;
        overflow: hidden;
        margin-bottom: 0px;

        border-top-left-radius: 5px;
        border-top-right-radius: 5px; 

    }

    .projectLogo_cont .projectLogo {
        height: 100%;
        width: 100%;
        max-width: 200px;
        max-height: 200px;
        min-height: 200px;
        object-fit: cover;
        object-position: center center;
        transform: scale(1.5);
        isolation: isolate;
        background: #fff;
        opacity: .3;
        transition: .9s;
    }

    .projectLogo_cont:hover .projectLogo {
        transform: scale(1.1);
        opacity: .7;
    }

    .projFooter {
        padding: 5px;
        width: 90%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .projDesc {
        text-align: left;
        margin: 8px 20px 0px 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6; /* number of lines to show */
        line-clamp: 6; 
        -webkit-box-orient: vertical;
        font-size: 14px;
        line-height: 20px;
    }

    .projFooter a,
    a {
        text-decoration: none;
        padding: 1px 7px;
        font-weight: bold;
        margin-top: 0px;
        margin-left: auto;
    }

    .projDet {
        width: 70%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding-bottom: 5px;
        padding-top: 5px;
        .projName {
            white-space: nowrap;
            z-index: 10;
            transition: .3s;
            margin-bottom: 0px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 93%;
        }
    }

    @media (prefers-color-scheme: dark) {
        .projFooter a,
        a {
            color: #fff;
        }
        .projectCont {
            background-color: #4d4d4d44;
        }
    }
    @media (prefers-color-scheme: light) {
        .projFooter a,
        a {
            color: #000;
        }

        .projectCont {
            background-color: #41414144;
        }
    }
    @media screen and (max-width: 650px) {
        .projectCont {
            width: 100%;
        }
        .projectLogo_cont .projectLogo {
            max-width: 150px;
        }
        .projDesc {
            font-size: 11px;
            margin: 8px 10px 0px 10px;
        }

        .projDet {
        .projName {
            font-size: 28px;
        }
    }

    }
</style>